export default "__VITE_ASSET__888dbc40__"